import { AIONZ_DIALOG_DATA, AionzDialogRef, CardTableModule } from '@aionzdev/design-system';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { TradingMatchSuggestion } from '../../../interfaces/trading-match-suggestion';
import { GenericPurchaseRequestDialogComponent } from '../generic-purchase-request-dialog/generic-purchase-request-dialog.component';
import { KanbanChipBadgeComponent } from '../../atoms/kanban-chip-badge/kanban-chip-badge.component';

@Component({
  selector: 'aionz-trading-match-parceria-dialog',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    CardTableModule,
    CurrencyPipe,
    GenericPurchaseRequestDialogComponent,
    KanbanChipBadgeComponent
  ],
  templateUrl: './trading-match-parceria-dialog.component.html',
  styleUrl: './trading-match-parceria-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TradingMatchParceriaDialogComponent {
  public suggestions = inject<TradingMatchSuggestion[]>(AIONZ_DIALOG_DATA);
  public dialogRef = inject(AionzDialogRef<TradingMatchParceriaDialogComponent, void>);

  approveSuggestion = output<TradingMatchSuggestion>();
  rejectSuggestion = output<TradingMatchSuggestion>();

  protected displayedColumns: string[] = [
    'requestedProductTitle',
    'suggestedProductTitle',
    'supplierName',
    'price',
    'similarityScore',
    'actions'
  ];

  protected close(): void {
    this.dialogRef.close();
  }

  protected similarityPercentage(suggestion: TradingMatchSuggestion): number {
    return Math.round(suggestion.similarityScore * 100);
  }

  protected onApprove(suggestion: TradingMatchSuggestion): void {
    this.approveSuggestion.emit(suggestion);
  }

  protected onReject(suggestion: TradingMatchSuggestion): void {
    this.rejectSuggestion.emit(suggestion);
  }
}
